define('glu/grid/filter/advancedSearch',['require','marionette','../../compositeView','../../itemView','handlebars','../../locale','hbs!./advancedSearch.hbs','../../dialog','../../util'],function(require) {
    'use strict';

    var Marionette = require('marionette'), // TODO Shouldn't need this - it's because we're usin§ `Marionette.getOption`
        CompositeView = require('../../compositeView'),
        ItemView = require('../../itemView'),
        Handlebars = require('handlebars'),
        locale = require('../../locale'),
        tpl = require('hbs!./advancedSearch.hbs'),
        dialog = require('../../dialog'),
        util = require('../../util');

    return CompositeView.extend({
        template: tpl,
        itemView: ItemView.extend({
            template: Handlebars.compile('')
        }),
        className: 'advanced-search',
        modalClass: 'modal-lg advanced-search-modal',
        itemViewContainer: '.search-control-list',
        totalFilters: 0,
        dialogTitle: '',
        dialogButtons: [],
        ui: {
            addFilterContainer: '.add-filter-container',
            applyAdvanced: 'input[data-hook="apply-advanced"]',
            addFilter: 'button[data-control="addFilter"]'
        },
        events: {
            'submit': 'handleSubmit',
            'click @ui.applyAdvanced': 'handleSubmit',
            'click @ui.addFilter': 'handleAddFilter'
        },
        constructor: function(opts) {
            CompositeView.prototype.constructor.call(this, opts);
            this.SearchViewClass = opts.filterViewClass;
        },
        initialize: function() {
            this.dialogTitle = locale.get('manageFilters');
            this.dialogButtons = [{
                text: locale.get('apply'),
                className: 'btn btn-primary',
                callback: 'handleSubmit'
            }, {
                text: locale.get('advancedSearch.cancel'),
                className: 'btn btn-tertiary',
                callback: 'cancel'
            }];
            // get the total number of filter items by removing the un-'filterable' ones
            var options = this.options.columns || this.columns;
            var filterOptions = util.filter(options.models, function(model) {
                return (model.get('filterable') !== false);
            });
            this.totalFilters = filterOptions.length;
        },

        cancel: function() {
            dialog.close();
        },
        onRender: function() {
            this.delegateEvents();
            this.handleAlreadyAddedFilters();
            this.addFirstFilter();
            this.showHideAddFilterButton();
        },

        addFirstFilter: function() {
            if (this.collection.isEmpty()) {
                this.addFilter(); // output the first filter selection
            }
        },

        handleAlreadyAddedFilters: function() {
            this.closeChildren();

            this.collection.each(function(model) {
                if (!model.get('field')) {
                    return;
                }
                this.addFilter(model);
            }, this);
        },

        showHideAddFilterButton: function() {
            var filtersLength = this.children.length;
            if (filtersLength >= this.totalFilters) {
                return this.ui.addFilter.hide();
            }
            this.ui.addFilter.show();
        },

        addFilter: function(model) {
            var filtersLength = this.children.length;
            if (filtersLength >= this.totalFilters) {
                return;
            }
            var optionsCollections = this.options.columns || this.columns,
                grid = this.options.grid || this.grid;

            var view = new this.SearchViewClass({
                filtersCollection: this.collection,
                collection: optionsCollections,
                first: this.children.length === 0,
                grid: grid,
                model: model,
                filterProc: this.options.filterProc,
                advancedSearch: true
            });

            view.render();
            this.listenTo(view, {
                'filter:remove': this.removeFilter,
                'filter': this.handleAddFilter
            });

            this.ui.addFilterContainer.append(view.el);

            this.children.add(view);
        },

        handleAddFilter: function(e) {
            this.addFilter();
            this.trigger('add', this, e);

            this.showHideAddFilterButton();
        },

        handleSubmit: function(e) {
            e.preventDefault();
            this.collection.reset(this.getFilters());
            this.trigger('submit', this, e);
            dialog.close();
        },

        itemViewOptions: function() {
            return {
                collection: Marionette.getOption(this, 'columns')
            };
        },

        getFilters: function() {
            // remove empty children
            var filters = this.children.map(function(child) {
                if (child.$el.html().length > 0) {
                    if (child.createFilter) {
                        return child.createFilter();
                    }
                    if (child.searchView && child.searchView.createFilter) {
                        return child.searchView.createFilter();
                    }
                } else {
                    return null;
                }
            });
            return (util.compact(filters));
        },

        removeFilter: function(filterView) {
            if (filterView) {
                this.removeChildView(filterView);
                if (this.children.length === 0) {
                    this.addFilter();
                }
                this.showHideAddFilterButton();
            }
        }
    });
});

